import {gsap} from "gsap";

(function ($) {
    $(document).ready(function () {

        //elastic button animation
        $('.button-elastic-animation').on('mouseenter', function () {

            gsap.to(this, {
                //width: '+=10px',
                duration: 0.4,
                transformOrigin: 'left center'
            });

            // add animation keyframe jelly
            $(this).css('animation', 'jelly 0.5s');

            // stop after finish
            setTimeout(() => {
                $(this).css('animation', 'none');
            }, 500);
        });

        $('.button-elastic-animation').on('mouseleave', function () {

            gsap.to(this, {
                //width: 'auto',
                duration: 0.4,
                transformOrigin: 'left center'
            });

            $(this).css('animation', 'jelly 0.5s');

            setTimeout(() => {
                $(this).css('animation', 'none');
            }, 500);
        });
    });
})(jQuery);